import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
	selector: '[click2change]'
})
export class Click2changeDirective {

	constructor(private el: ElementRef, private renderer: Renderer) {
		el.nativeElement.addEventListener("click", function (event) {
			//event.stopImmediatePropagation();
			//event.stopPropagation();
			event.preventDefault();//block duplicate change event

			console.debug("@@>   Click2changeDirective triggerred");
			el.nativeElement.dispatchEvent(new Event('change'))
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/directives/click2change.directive.ts